module.exports = __webpack_public_path__ + "static/media/companySelected.96caa5cc.svg";